var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M8,20a1,1,0,0,1-.651-.242A32.289,32.289,0,0,1,3.562,15.8a20.91,20.91,0,0,1-2.456-3.752A9.442,9.442,0,0,1,0,7.922a8,8,0,0,1,16,0,9.442,9.442,0,0,1-1.106,4.123A20.91,20.91,0,0,1,12.438,15.8a32.289,32.289,0,0,1-3.787,3.961A1,1,0,0,1,8,20ZM8,2A5.968,5.968,0,0,0,2,7.922c0,1.591.8,3.493,2.372,5.653A31.188,31.188,0,0,0,8,17.645a30.887,30.887,0,0,0,3.629-4.071C13.2,11.415,14,9.513,14,7.922A5.968,5.968,0,0,0,8,2Zm0,9a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,8,11ZM8,6A1.5,1.5,0,1,0,9.5,7.5,1.5,1.5,0,0,0,8,6Z",
    transform: "translate(4 2)",
    fill: "#505358"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Location"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location",
    clipPath: "url(#clip-Location)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin",
    transform: "translate(4 2.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor-2",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M8,20a1,1,0,0,1-.651-.242A32.289,32.289,0,0,1,3.562,15.8a20.91,20.91,0,0,1-2.456-3.752A9.442,9.442,0,0,1,0,7.922a8,8,0,0,1,16,0,9.442,9.442,0,0,1-1.106,4.123A20.91,20.91,0,0,1,12.438,15.8a32.289,32.289,0,0,1-3.787,3.961A1,1,0,0,1,8,20ZM8,2A5.968,5.968,0,0,0,2,7.922c0,1.591.8,3.493,2.372,5.653A31.188,31.188,0,0,0,8,17.645a30.887,30.887,0,0,0,3.629-4.071C13.2,11.415,14,9.513,14,7.922A5.968,5.968,0,0,0,8,2Zm0,9a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,8,11ZM8,6A1.5,1.5,0,1,0,9.5,7.5,1.5,1.5,0,0,0,8,6Z",
    transform: "translate(0 0)",
    fill: "#505358"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.11f2cd09004be8b9d6b1c9c16a6e8d6b.svg";
export { ForwardRef as ReactComponent };